export type AgreementNoteReminder = {
    id: string;
    agreementId: string;
    note: string;
    reminder: boolean;
    subject?: string;
    to?: string[];
    //reminderDate?: string;
    //reminderTime?: string;
    reminderDate?: string;
    created: string;
    createdBy: string;
};
